import React, { useState, useEffect } from "react";
import UserForm from "../../../Components/Form/UserForm";
import { useNavigate } from "react-router-dom";
import { showErrorToast, showSuccessToast } from "../../../toastmsg";
import { auth, db } from "../../../firebase";
import { updateProfile } from "firebase/auth";
import { doc, getDoc, updateDoc } from "firebase/firestore";

const Profile = () => {
  const navigate = useNavigate();
  const currentUser = auth.currentUser;
  const [initialData, setInitialData] = useState<any>(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      if (!currentUser) return;
      try {
        const userDoc = await getDoc(doc(db, "users", currentUser.uid));
        if (userDoc.exists()) {
          setInitialData({
            ...userDoc.data(),
            email: currentUser.email,
            uid: currentUser.uid,
          });
        }
      } catch (error) {
        console.error("Failed to fetch user data:", error);
        showErrorToast("Failed to load profile");
      }
    };

    fetchUserData();
  }, [currentUser]);

  const handleUpdate = async (formData: any) => {
    setSubmitting(true);
    try {
      const { firstName, lastName } = formData;

      await updateDoc(doc(db, "users", currentUser!.uid), {
        firstName,
        lastName,
        // name,
      });

      await updateProfile(currentUser!, {
        displayName: firstName,
        // displayName: name,
      });

      showSuccessToast("Profile updated successfully");
      navigate("/dashboard");
    } catch (error) {
      console.error("Update failed:", error);
      showErrorToast("Failed to update profile");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-lg font-bold mb-4">View Profile</h2>

      <UserForm
        initialData={initialData}
        onSubmit={handleUpdate}
        onCancel={() => navigate("/dashboard")}
        disabled={submitting}
        profileMode={true} // ✅ tells UserForm to use getProfileFields automatically
        hideButton={true}
      />
    </div>
  );
};

export default Profile;
